/**
 * O endereço de um CEP (03/11/2026), para completar o endereço no agendamento
 * da consulta.
 *
 * Quem pergunta aos Correios é o SERVIDOR, e não o navegador: a BrasilAPI
 * primeiro e a ViaCEP de reserva. Assim o terceiro recebe só o CEP, sem o IP
 * nem o navegador de quem atende, e a tela não depende de o provedor aceitar a
 * origem dela. Nada aqui é dado de pessoa: um CEP sozinho é uma rua.
 */

import { z } from 'zod';

/** O CEP só com os 8 dígitos. Com traço ou ponto é recusado: quem chama limpa. */
export const CepSchema = z.string().regex(/^\d{8}$/, 'CEP com 8 dígitos, só os números.');

/** O pedido: o CEP no corpo, nunca no caminho, que vai para os logs (#1187). */
export const ConsultaDoCepSchema = z.object({ cep: CepSchema });
export type ConsultaDoCep = z.infer<typeof ConsultaDoCepSchema>;

/**
 * O endereço como o provedor o tem. Cada campo pode faltar: CEP geral de cidade
 * pequena não tem rua nem bairro, e a tela pede o que faltar.
 */
export const EnderecoDoCepSchema = z.object({
  cep: CepSchema,
  logradouro: z.string().nullable(),
  bairro: z.string().nullable(),
  cidade: z.string().nullable(),
  /** A sigla do estado, em maiúsculas (`SP`). */
  uf: z.string().nullable(),
});
export type EnderecoDoCep = z.infer<typeof EnderecoDoCepSchema>;
